module.exports = __webpack_public_path__ + "static/media/RightArrow.5157054a.svg";